import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-unit-details-header',
  templateUrl: './unit-details-header.component.html',
  styleUrls: ['./unit-details-header.component.scss'],
})
export class UnitDetailsHeaderComponent {
  @Output() month_change: EventEmitter<number> = new EventEmitter<number>();
  @Output() year_change: EventEmitter<number> = new EventEmitter<number>();
}
